module.exports = __webpack_public_path__ + "img/apple.b5d03af3.svg";